

export class FuelStationOutputWithOutStatus implements IFuelStationOutputWithOutStatus {
    /** The auto-generated id of the fuel station master */
    fuel_station_id!: number;
    /** The fuel station name with 255 character limit */
    fuel_station_name!: string;

    constructor(data?: IFuelStationOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuel_station_id = _data["fuel_station_id"];
            this.fuel_station_name = _data["fuel_station_name"];
        }
    }

    static fromJS(data: any): FuelStationOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FuelStationOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuel_station_id"] = this.fuel_station_id;
        data["fuel_station_name"] = this.fuel_station_name;
        return data; 
    }
}

export interface IFuelStationOutputWithOutStatus {
    /** The auto-generated id of the fuel station master */
    fuel_station_id: number;
    /** The fuel station name with 255 character limit */
    fuel_station_name: string;
}

